"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTargetTagsProperty = exports.targetTagsPropertyDefinition = void 0;
exports.targetTagsPropertyDefinition = {
    view: {
        label: 'Targeting',
        hint: 'The Promotion will target content tagged with these tags or place promotions on the specified stories.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: [
                'collection',
                'discipline',
                'playground',
                'story',
            ],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'target-tags',
};
const isTargetTagsProperty = (prop) => {
    return prop.name === exports.targetTagsPropertyDefinition.name;
};
exports.isTargetTagsProperty = isTargetTagsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFyZ2V0LXRhZ3MucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90YXJnZXQtdGFncy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxXQUFXO1FBQ2xCLElBQUksRUFBRSx3R0FBd0c7S0FDL0c7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixZQUFZO2dCQUNaLFlBQVk7Z0JBQ1osWUFBWTtnQkFDWixPQUFPO2FBQ1I7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxhQUFhO0NBQ1ksQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQyJ9